module.exports = __webpack_public_path__ + "media/images/vendors/category3-811d4e92252dd69415cf2fd4aee87b09.jpg";